import { render, staticRenderFns } from "./company-culture.vue?vue&type=template&id=510f7e8a&scoped=true&"
import script from "./company-culture.vue?vue&type=script&lang=js&"
export * from "./company-culture.vue?vue&type=script&lang=js&"
import style0 from "./company-culture.vue?vue&type=style&index=0&id=510f7e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f7e8a",
  null
  
)

export default component.exports